import { Risco } from 'graphql/types.generated'

import { ContentCardSection } from '../../components/ContentCardSection'
import { RastreamentosListCard } from './RastreamentosListCard'

export interface RastreamentosCardProps {
  riscos: ReadonlyArray<Risco>
  loading: boolean
  canRender: boolean
  dataTestId: string
}

export function RastreamentosCard(props: Readonly<RastreamentosCardProps>) {
  const { riscos, loading, canRender, dataTestId } = props

  return (
    <ContentCardSection
      isLoading={loading}
      messageLoading='Carregando dados dos rastreamentos'
      canRender={canRender}
      dataTestId={dataTestId}
    >
      <RastreamentosListCard riscos={riscos} />
    </ContentCardSection>
  )
}
